"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
window._ = require('lodash');
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
    $(function () {
        $("body").tooltip({
            // option required for tooltips not to flicker
            // inside the .table-responsive div element
            boundary: "window",
            selector: '[data-toggle="tooltip"]',
            animation: false,
            // option required for tooltips not to trigger
            // on buttons clicks
            trigger: "hover"
        });
    });
}
catch (e) { }
/**
 * We'll extend Vue prototype methods.
 */
var vue_1 = __importDefault(require("vue"));
var event_bus_1 = require("./event-bus");
var lodash_1 = __importDefault(require("lodash"));
var bootstrap_vue_1 = __importDefault(require("bootstrap-vue"));
var vue_cookies_1 = __importDefault(require("vue-cookies"));
var roles_json_1 = __importDefault(require("../roles.json"));
var permissions_json_1 = __importDefault(require("../permissions.json"));
vue_1.default.use({
    install: function (VueComponent) {
        VueComponent.prototype.$roles = roles_json_1.default;
        VueComponent.prototype.$permissions = permissions_json_1.default;
    }
});
vue_1.default.use(bootstrap_vue_1.default, {
    BToast: {
        autoHideDelay: 1500,
        toaster: "b-toaster-top-right",
        variant: "success"
    }
});
vue_1.default.use(vue_cookies_1.default);
window.$cookies = vue_cookies_1.default;
vue_1.default.prototype.$eventBus = event_bus_1.EventBus;
window.$lang = vue_1.default.prototype.$lang = vue_1.default.prototype.__ = function (text, args) {
    var value = lodash_1.default.get(window.i18n, text) || text;
    lodash_1.default.eachRight(args, function (paramValue, paramKey) {
        value = lodash_1.default.replace(value, ":" + paramKey, paramValue);
    });
    return value;
};
var views_1 = __importDefault(require("./config/views"));
vue_1.default.use({
    install: function (VueConstructor) {
        VueConstructor.prototype.$views = views_1.default;
    }
});
require("./directives");
vue_1.default.prototype.$notification = function (type, message, title) {
    var defaultMessages = {
        "success": window.$lang("Sukces!"),
        "warning": window.$lang("Ostrzeżenie!"),
        "danger": window.$lang("Wystąpił błąd!"),
        "default": window.$lang("Informacja")
    };
    this.$bvToast.toast(message, {
        variant: type,
        title: title ? title : defaultMessages[type]
    });
};
var permissions_1 = __importDefault(require("./mixins/permissions"));
var axios_1 = __importDefault(require("./mixins/axios"));
vue_1.default.mixin(permissions_1.default);
vue_1.default.mixin(axios_1.default);
var vClickOutside = require("v-click-outside");
vue_1.default.use(vClickOutside);
require("bootstrap-select");
$(function () {
    $(document).on("show.bs.dropdown", ".table-responsive", function () {
        $(this).css("overflow", "inherit");
    }).on("hide.bs.dropdown", ".table-responsive", function () {
        $(this).css("overflow", "auto");
    });
});
//
// window.Pusher = require("pusher-js");
//
// window.Echo = new Echo({
//     broadcaster: "pusher",
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
